<template>
	<div>
		<div class="row">
			<div class="column-sidebar-left">
				<AdvancedSearchMenu></AdvancedSearchMenu>
			</div>
			<div class="column-main-right">
				<div class="content-container">
					<div class="header">
						<div class="title">Topic</div>
					</div>
					<div class="content search-form">
                        <table>
                            <tr>
                                <td>
                                    <div class="label">Started By</div>
                                </td>
                                <td>
                                    <div class="input-cell">
                                        <input class="started-by-input" type="text" v-model="startedBy">
                                        <div><em>separate search terms with commas</em></div>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div class="label">Exact Match</div>
                                </td>
                                <td>
                                    <input type="checkbox" v-model="exactMatch">                                    
                                </td>
                            </tr>
                        </table>

                        <hr />

                        <table>
                            <tr>
                                <td>
                                    <div class="label">Topic Start Date</div>
                                </td>
                                <td>
                                    <div class="input-cell">
                                        <div class="start-date-value">
                                            <div>
                                                <input type="radio" name="between" value="between" v-model="startDateType">
                                                <label for="between">Between</label>
                                                <input type="radio" name="before" value="before" v-model="startDateType">
                                                <label for="before">Before</label>
                                                <input type="radio" name="after" value="after" v-model="startDateType">
                                                <label for="after">After</label>
                                            </div>
                                            <div>
                                                <vc-date-picker :class="{hidden: !(startDateType == 'between' || startDateType == 'after')}"
                                                    v-model='dateAfter'
                                                    class="date-picker"
                                                    :max-date="dateBefore"
                                                    :input-props='{
                                                        style:"width:90px; font-size: 14px; margin-bottom: 6px;"
                                                    }'
                                                />
                                                <span style="padding: 0px 6px;" :class="{hidden: !(startDateType == 'between')}">and</span>
                                                <vc-date-picker :class="{hidden: !(startDateType == 'between' || startDateType == 'before')}"
                                                    v-model='dateBefore'
                                                    class="date-picker"
                                                    :min-date="dateAfter"
                                                    :input-props='{
                                                        style:"width:90px; font-size: 14px; margin-bottom: 6px;"    
                                                    }'
                                                />
                                            </div>
                                        </div>
                                        
                                    </div>
                                </td>
                            </tr>
                            
                        </table>

                        <hr />

                        <table>
                            <tr>
                                <td>
                                    <div class="label">Topic Title</div>
                                </td>
                                <td>
                                    <div class="input-cell">
                                        <input class="title-input" type="text" v-model="title">                                        
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div class="label">Exact Match</div>
                                </td>
                                <td>
                                    <input type="checkbox" v-model="exactMatchTitle">                                 
                                </td>
                            </tr>
                        </table>

                        <hr/>

                        <table>
                            <tr>
                                <td>
                                    <div class="label">Post Count</div>
                                </td>
                                <td>
                                    <div class="input-cell">
                                        <div class="post-count-value">
                                            <input type="radio" name="greater" value="greater" v-model="postCountType">
                                            <label for="greater">Greater Than</label>
                                            <input type="radio" name="less" value="less" v-model="postCountType">
                                            <label for="less">Less Than</label>
                                            
                                        </div>                                  
                                        <input class="post-count-input" type="number" v-model="postCount">
                                    </div>
                                </td>
                            </tr>                            
                        </table>

                        <hr/>

                        <div class="search-button-container">
                            <button class="search-button" @click="search">Search</button>
                        </div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import AdvancedSearchMenu from "../../components/Search/AdvancedSearchMenu";
import dialogs from '../../modules/dialogs';
import api from '../../api/api';
import moment from 'moment';

export default {
    data() {
        return {
            startedBy: null,
            exactMatch: null,
            startDateType: null,
            dateAfter: null,
            dateBefore: null,
            title: null,
            exactMatchTitle: null,
            postCountType: null,
            postCount: null,
            attatchments: null,
        };
    },
	components: {
        AdvancedSearchMenu,
    },
    watch: {
        startDateType(newValue) {
            if (newValue == "before") {
                this.dateAfter = null;
            }
            else if(newValue == "after") {
                this.dateBefore = null;
            }
        }
    },
    methods: {
        async search() {
            let requestBody = {
                startedBy: this.startedBy,
                exactMatch: this.exactMatch,
                startDateType: this.startDateType,
                dateAfter: this.dateAfter != null ? moment(this.dateAfter).utc().format() : null,
                dateBefore: this.dateBefore != null ? moment(this.dateBefore).utc().format() : null,
                title: this.title,
                exactMatchTitle: this.exactMatchTitle,
                postCountType: this.postCountType,
                postCount: parseInt(this.postCount),
                attatchments: this.attatchments
            }

            var hasValues = false;
            if (requestBody.startedBy && requestBody.startedBy !== "" && requestBody.startedBy !== null) hasValues = true;
            if (requestBody.dateAfter && requestBody.dateAfter !== null) hasValues = true;
            if (requestBody.dateBefore && requestBody.dateBefore !== null) hasValues = true;
            if (requestBody.title && requestBody !== "" && requestBody.title !== null) hasValues = true;            

            if (!hasValues) {
                await dialogs.alertAsync("Please enter at least one of: Started By, Title or Date");
                return;
            }

            api.post('/search/advancedTopic', requestBody).then((r) => {
                this.$store.commit('setSearchedIdTopics', r.data);
                this.$router.push('/topics/list/search')
            });
        },
    },
};
</script>

<style scoped>

hr {
    width: 525px;
    margin-left: 0;
    
}
td {
    vertical-align: top;
}
div.label {
    width: 150px;    
}
div.input-cell {
    width: 350px;
}
input {
    width: 100%;
}
input[type="checkbox"] {
    width: auto;
}
input[type="radio"] {
    width: auto;
}
input[type="number"] {
    width: 50px;
}
.hidden{
    visibility: hidden;
}
button.search-button {
    margin-left: 450px;
}
</style>